'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendOfflineMessageFailed = exports.sendOfflineMessageSucceeded = exports.sendOfflineMessageRequested = undefined;
exports.stageAwayMessage = stageAwayMessage;
exports.setStagedMessageStatusesToPublished = setStagedMessageStatusesToPublished;
exports.sendOfflineMessage = sendOfflineMessage;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _filter = require('transmute/filter');

var _filter2 = _interopRequireDefault(_filter);

var _reduxActions = require('redux-actions');

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ConversationsActions = require('conversations-core/actions/ConversationsActions');

var _PubNubMessageFactory = require('conversations-schema/factories/PubNubMessageFactory');

var _PubNubMessageTypes = require('conversations-schema/constants/PubNubMessageTypes');

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _conversationSelectors = require('conversations-core/selectors/conversationSelectors');

var _widgetDataSelectors = require('conversations-core/selectors/widgetDataSelectors');

var _ConversationModel = require('conversations-schema/models/ConversationModel');

var _SenderTypes = require('conversations-schema/constants/SenderTypes');

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _VisitorApiClient = require('conversations-visitor-ui/VisitorApiClient');

var VisitorApiClient = _interopRequireWildcard(_VisitorApiClient);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sendOfflineMessageRequested = exports.sendOfflineMessageRequested = (0, _reduxActions.createAction)(_ActionTypes2.default.SEND_OFFLINE_MESSAGE, function (message) {
  return { message: message };
});

var sendOfflineMessageSucceeded = exports.sendOfflineMessageSucceeded = (0, _reduxActions.createAction)(_ActionTypes2.default.SEND_OFFLINE_MESSAGE_SUCCEEDED, function (channel, message, updated) {
  return { channel: channel, message: message, updated: updated };
});

var sendOfflineMessageFailed = exports.sendOfflineMessageFailed = (0, _reduxActions.createAction)(_ActionTypes2.default.SEND_OFFLINE_MESSAGE_FAILED, function (channel, message, updated) {
  return { channel: channel, message: message, updated: updated };
});

function stageAwayMessage() {
  return function (dispatch, getState) {
    var _metadata;

    var channel = (0, _conversationSelectors.getCurrentChannel)(getState());

    var awayMessage = (0, _PubNubMessageFactory.buildUnpublishedMessage)({
      metadata: (_metadata = {}, _defineProperty(_metadata, _PubNubMessageTypes.MESSAGE_TYPE_ID, _PubNubMessageTypes.OFFLINE), _defineProperty(_metadata, 'text', (0, _widgetDataSelectors.getAwayMessage)(getState())), _defineProperty(_metadata, 'from', _RoleTypes2.default.REP), _metadata),
      senderId: (0, _widgetDataSelectors.getResponderUserId)(getState()),
      senderType: _SenderTypes.AGENT
    });

    dispatch((0, _ConversationsActions.addMessageToConversation)({ channel: channel, message: awayMessage }));
  };
}

function setStagedMessageStatusesToPublished() {
  return function (dispatch, getState) {
    var channel = (0, _conversationSelectors.getCurrentChannel)(getState());
    var conversation = (0, _conversationSelectors.getCurrentConversation)(getState());

    var initialMessage = (0, _pipe2.default)(_ConversationModel.getMessagesInHistory, (0, _filter2.default)(_ConversationalMessageModel.isInitialMessage), function (messages) {
      return messages.first();
    })(conversation);

    var awayMessage = (0, _pipe2.default)(_ConversationModel.getMessagesInHistory, (0, _filter2.default)(_ConversationalMessageModel.isFromRep), (0, _filter2.default)(_ConversationalMessageModel.isOfflineMessage), function (messages) {
      return messages.first();
    })(conversation);

    [initialMessage, awayMessage].forEach(function (message) {
      if (!message) return;

      dispatch((0, _ConversationsActions.updateMessageInConversation)({
        channel: channel,
        message: message,
        updated: (0, _PubNubMessageFactory.buildPublishedMessage)(message)
      }));
    });
  };
}

function sendOfflineMessage(_ref) {
  var message = _ref.message,
      channel = _ref.channel;

  return function (dispatch, getState) {
    dispatch(sendOfflineMessageRequested(message));

    var offlineSuccessCb = function offlineSuccessCb() {
      var updated = (0, _PubNubMessageFactory.buildPublishedMessage)(message);
      dispatch(sendOfflineMessageSucceeded(channel, message, updated));
    };

    var offlineFailureCb = function offlineFailureCb() {
      var updated = (0, _PubNubMessageFactory.buildPublishFailedMessage)(message);
      dispatch(sendOfflineMessageFailed(channel, message, updated));
    };

    VisitorApiClient.sendOfflineMessage({
      sessionId: (0, _widgetDataSelectors.getSessionId)(getState()),
      portalId: _hubspot2.default.get(),
      message: message
    }).then(offlineSuccessCb, offlineFailureCb).done();
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/actions/OfflineModeActions.js
// module id = 190
// module chunks = 0 1